import PropTypes from 'prop-types'
import GridTypeToggle from 'shared/components/grid-type/grid-type'
import SharedSectionHeader from 'shared/components/section-header'
import { giphyLightGrey } from 'shared/css/colors.css'
import styled from 'styled-components'
import AutoPlay from '../../containers/auto-play/auto-play'
import { margin } from '../../shared/constants.css'

const SectionHeader = styled(SharedSectionHeader)`
    line-height: ${props => (props.hasAutoPlay ? 21 : 14)}px;
    padding: ${props => (props.hasAutoPlay ? 2 : 0)}px 0;
`
const Container = styled.div`
    padding: ${margin};
    color: ${giphyLightGrey};
    letter-spacing: 0.25;
    font-size: 15px;
    font-weight: 600;
    text-transform: capitalize;
    text-align: left;
    -webkit-font-smoothing: antialiased;
`

const CenteredFlex = styled.div`
    display: flex;
    align-items: flex-start;
`

const ButtonContainer = styled.div`
    margin-left: auto;
    flex-shrink: 0;
`

const HeaderSubtitle = ({ subtitle, autoPlay, toggleGrid }) => (
    <Container>
        <CenteredFlex>
            <SectionHeader label={subtitle} hasAutoPlay={autoPlay} />
            <ButtonContainer>
                {toggleGrid && <GridTypeToggle />}
                {autoPlay && <AutoPlay />}
            </ButtonContainer>
        </CenteredFlex>
    </Container>
)

HeaderSubtitle.propTypes = {
    autoPlay: PropTypes.bool,
    subtitle: PropTypes.string.isRequired,
    toggleGrid: PropTypes.bool,
}

export default HeaderSubtitle
